import classNames from 'classnames';
import classes from './IconButton.module.scss';
import IconWrapper from '../wrapper/IconWrapper';

function IconButton({ children, onClick, withIconWrapper, className, iconWrapperProps, ...props }) {
    if (withIconWrapper) {
        return (
            <button
                onClick={onClick}
                className={classNames(classes.iconButton, className)}
                {...props}
            >
                <IconWrapper {...iconWrapperProps}>{children}</IconWrapper>
            </button>
        );
    }
    return (
        <button onClick={onClick} className={classNames(classes.iconButton, className)} {...props}>
            {children}
        </button>
    );
}
export default IconButton;

export function NoStyleButton({ children, onClick, className, ...props }) {
    return (
        <button onClick={onClick} className={classNames(classes.iconButton, className)} {...props}>
            {children}
        </button>
    );
}
